/* eslint-disable no-useless-escape */
'use strict';

function varaitionNotSelectedError($pdpContainer) {
	let nonSelectedVariations = $pdpContainer.find('.variationOption').not(':has(.variation-value.selected)');
	for (let i = 0; i < nonSelectedVariations.length; i++) {
		let errorMsg = $(nonSelectedVariations[i]).data('attr-missing-error');
		$(nonSelectedVariations[i]).addClass('variation-missing-error');
		$(nonSelectedVariations[i]).find('.variation-not-selected-error').text(errorMsg);
		$(document).trigger('gtm:pdpVariationErrors', errorMsg);
	}
	if($pdpContainer.find('.variation-missing-error').length > 0) {
		$(document).scrollTop($pdpContainer.find('.variation-missing-error').offset().top);
	}
}


/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function displayMessage(data, button) {
	$.spinner().stop();
	var status;
	var icon;
	if (data.success) {
		if (button.find($('i')).hasClass('fa-heart-o')) {
			button.find($('i')).removeClass('fa-heart-o').addClass('fa-heart');
		}
		status = 'alert-success';
		icon ='&#10003;';
	} else if(!data.success && data.isMaster && $('.product-detail').length > 0) {
		let setItemEle = button.parents('.product-detail.set-item');
		let isProductSet = setItemEle && setItemEle.length > 0 ? true : false;
		let productContainer = isProductSet ? setItemEle : $('.product-detail');
		varaitionNotSelectedError($(productContainer));
		return;
	} else {
		status = 'alert-danger';
		icon ='&times;';
	}

	if ($('.add-to-wishlist-messages').length === 0) {
		if($('.page').data('action') == 'Product-Show') {
			$('.pdp-wishlist-message-block').append(
				'<div class="add-to-wishlist-messages "></div>'
			);
		} else {
			$('body').append(
				'<div class="add-to-wishlist-messages "></div>'
			);
		}
	}

	$('.add-to-wishlist-messages')
		.append(
			'<div class="add-to-wishlist-alert d-flex text-center ' + status + '">' +
			'<div class="tick tick-cta">' + icon + '</div> ' + '<div class="wishlistmsgcss">' + '<p>' + data.msg + '</p>' +
			'<button type="button" class="close" data-bs-dismiss="alert" aria-label="Close">' +
			'<span aria-hidden="true">&times;</span>' +
			'</button>' + '</div>' + '</div>');

	setTimeout(function () {
		$('.add-to-wishlist-messages').remove();
		button.removeAttr('disabled');
	}, 8000);
	$('body').trigger('cart:update', data);
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotalsAfterWishList(data) {
	// eslint-disable-next-line no-mixed-spaces-and-tabs
	$('body').trigger('cart:updateProratedMessage', data);
	$('.number-of-items').empty().append(data.resources.numberOfItems);
	$('.breadcrumb-item a:contains("Cart")').text(`Cart (${data.numItems})`);
	$('.shipping-cost').empty().append('-');
	$('.tax-total').empty().append('-');
	$('.grand-total').empty().append(data.totals.grandTotalNet);
	$('.sub-total').empty().append(data.totals.subTotal);
	//prorated discount shown if value is not zero.
	if (data.totals.discountedPriceTotal.value > 0) {
		$('.prorated-price-main').removeClass('d-none');
		$('.proratedDiscount-total').empty().append('-'+data.totals.discountedPriceTotal.formatted);
	} else {
		$('.prorated-price-main').addClass('d-none');
	}
	$('.minicart-quantity').empty().append(data.numItems);
	$('.minicart-link').attr({
		'aria-label': data.resources.minicartCountOfItems,
		title: data.resources.minicartCountOfItems
	});
	if (data.totals.orderLevelDiscountTotal.value > 0) {
		$('.order-discount').removeClass('hide-order-discount');
		$('.order-discount-total').empty()
			.append('- ' + data.totals.orderLevelDiscountTotal.formatted);
	} else {
		$('.order-discount').addClass('hide-order-discount');
	}

	if (data.totals.shippingLevelDiscountTotal.value > 0) {
		$('.shipping-discount').removeClass('hide-shipping-discount');
		$('.shipping-discount-total').empty().append('- ' +
			data.totals.shippingLevelDiscountTotal.formatted);
	} else {
		$('.shipping-discount').addClass('hide-shipping-discount');
	}
	//order discount shown if value is not zero.
	if (data.totals.orderLevelDiscountTotal.value > 0) {
		$('.order-discount-row').removeClass('d-none');
		$('.order-discount-total').empty().append('- '+data.totals.orderLevelDiscountTotal.formatted);
	} else {
		$('.order-discount-row').addClass('d-none');
	}
	//Promo amount shown if value is not zero.
	if (data.totals.promoAppliedAmount.value > 0) {
		$('.promo-row').removeClass('d-none');
		$('.promo-total-applied-amount').empty().append('- '+data.totals.promoAppliedAmount.formatted);
	} else {
		$('.promo-row').addClass('d-none');
	}

	data.items.forEach(function (item) {
		if (data.totals.orderLevelDiscountTotal.value > 0) {
			$('.coupons-and-promos').empty().append(data.totals.discountsHtml);
		}
		if (item.renderedPromotions && !item.customProratedPrice) {
			$('.item-' + item.UUID).empty().append(item.renderedPromotions);
		} else {
			$('.item-' + item.UUID).empty();
		}
		$('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
		$('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
		if (item.hasAttached) {
			$('.item-total-' + item.UUID)
				.find('.line-item-total-price-amount')
				.html(item.engravingTotalPrice);
			if (item.cyoTotalProratedDiscount!='') {
				var customProratedMessage = '-'+item.cyoTotalProratedDiscount+ ' ' +item.proratedCalloutMsg;
				$('.item-total-' + item.UUID).find('.cyoProrated').html(customProratedMessage);
			}
			else{
				$('.item-total-' + item.UUID).find('.cyoProrated').html('');
			}
		} else {
			$('.item-total-' + item.UUID)
				.empty()
				.append(item.priceTotal.renderedPrice);
			if (item.customProratedPrice!=='') {
				// eslint-disable-next-line no-redeclare
				var customProratedMessage = '-'+item.customProratedPrice + ' ' +item.proratedCalloutMsg;
				$('.item-total-' + item.UUID).find('.proratedPrice').html(customProratedMessage);
			}
			else{
				$('.item-total-' + item.UUID).find('.proratedPrice').html('');
			}
		}
	});
}

/**
 * hides or show attach button based on 
 */
function updateCYOAttachButton(data) {
	data.items.forEach(function (item) {
		if (item.attachableCharmsInCart && item.attachableCharmsInCart.length === 0) {
			let attachButton = $('.uuid-' + item.UUID).find('.cyo-attach-wrapper');
			attachButton.addClass('d-none');
		}
	});
}

/**
 * Prepare a sanitized input for the listName parameter
 * Pass the field to be sanitized
 *
 * @return {array} - sanitized string
 */
function sanitizeFieldInput(inputString) {
	if(inputString){
		var outputString = '';

		outputString = inputString.replace(/<script[^>]*?>.*?<\/script>/gi, '').replace(/<[\/\!]*?[^<>]*?>/gi, '').
			replace(/<style[^>]*?>.*?<\/style>/gi, '').
			replace(/<![\s\S]*?--[ \t\n\r]*>/gi, '').
			replace(/&nbsp;/g, '');

		return outputString;

	}
}

function updateBonusItemTemplate(template){
	if(template){
		$('.bonus-product-list').remove();
		$('.cart-page-left-section .card.product-info:last').after(template);
	}
}

module.exports = {
	addToWishlistCart : function (){
		$('.add-to-wish-list-cart').on('click', function (e) {
			e.preventDefault();
			var url = $(this).data('href');
			var fromCart = $(this).data('fromcart') || null;
			var button = $(this);
			var pid = $(this).closest('.product-detail').find('.product-id').html() || $(this).data('pid');
			var uuid = $(this).data('uuid');
			var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
			var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
			var productRating = $.trim($(this).data('ratings'));
			var navigatedPDPInfo = $.trim($(this).data('navlist'));
			var stlID = $.trim($(this).data('stlid'));
			var analyticsAddToWishlistData = [];
			if (productRating && productRating > 0) {
				analyticsAddToWishlistData = [{'pid': pid, 'listName': sanitizeFieldInput(navigatedPDPInfo), 'productRating': parseFloat(productRating)}];
			} else {
				analyticsAddToWishlistData = [{'pid': pid, 'listName': sanitizeFieldInput(navigatedPDPInfo)}];
			}
			optionId = optionId || null;
			optionVal = optionVal || null;
			if (!url || !pid) {
				return;
			}

			if(stlID){
				analyticsAddToWishlistData[0].stlID = stlID;
			}
			var cyoItem = $(this).closest('.product-info').find('.cyo-set-details .line-item-id');
			$.spinner().start();
			$(this).attr('disabled', true);
			$.ajax({
				url: url,
				type: 'post',
				dataType: 'json',
				data: {
					pid: pid,
					optionId: optionId,
					optionVal: optionVal,
					fromCart: fromCart,
					pliUUID: uuid,
					uuid: uuid,
					analyticsAddToWishlistData: encodeURIComponent(JSON.stringify(analyticsAddToWishlistData)),
					csrf_token:$.trim($('input[name=csrf_token]').val())
				},
				success: function (data) {
					if (data.error) {
						displayMessage(data, button);

						if (data.basketModel.valid.error == true && (data.basketModel.valid.message !== null || data.basketModel.valid.message !== 'null')) {
							var isStoreSelectedError = data.basketModel.myStore.store == null && data.basketModel.myStore.distance == 0 ? false : true;
							if(isStoreSelectedError == false) {
								$('.checkout-continue').find('.checkout-btn')
									.attr('data-store-selected', 'true');
							} else {
								$('.checkout-continue').find('.checkout-btn')
									.attr('data-out-of-stock', 'true');
							}
						} else {
							$('.checkout-continue').find('.checkout-btn')
								.attr('data-out-of-stock', 'false')
								.attr('data-store-selected', 'false');
						}
						return;
					} else {
						displayMessage(data, button);
						if (data.cyoSet) {
							if(cyoItem){
								var pids = [];
								$(cyoItem).each(function(){
									pids.push($(this).text().trim());
								});
								(pids.length > 0 ) ? $('body').trigger('cart:movetowishlist', pids.join(',')) : '';
							}
						}else{
							if(data.pid){
								$('body').trigger('cart:movetowishlist', data.pid);
							}
						}
						if (data.basketModel.numItems == 0){
							window.location.reload();
						} else {
							if (data.basketModel.isPickupShipmentEligible && data.basketModel.isPickupShipmentEligible == true) {
								$('#pickup').removeAttr('disabled');
								$('.delivery-pickup-info-section').removeClass('disabled');
							} else {
								$('#pickup').attr('disabled');
								$('.delivery-pickup-info-section').addClass('disabled');
							}
							$('.product-info.uuid-' + uuid).remove();
							updateCartTotalsAfterWishList(data.basketModel);
							updateCYOAttachButton(data.basketModel);				
							if(data.basketModel.hasBonusProduct){
								if(data.basketModel.bonusItemsTemplate){
									updateBonusItemTemplate(data.basketModel.bonusItemsTemplate);
								}
							}else{
								$('.bonus-product-list').remove();
							}
							if (data.basketModel.valid.error == true && (data.basketModel.valid.message !== null || data.basketModel.valid.message !== 'null')) {
								var isStoreSelected = data.basketModel.myStore.store == null && data.basketModel.myStore.distance == 0 ? false : true;
								if(isStoreSelected == false) {
									$('.checkout-continue').find('.checkout-btn')
										.attr('data-store-selected', 'true');
								} else {
									$('.checkout-continue').find('.checkout-btn')
										.attr('data-out-of-stock', 'true');
								}
							} else {
								$('.checkout-continue').find('.checkout-btn')
									.attr('data-out-of-stock', 'false')
									.attr('data-store-selected', 'false');
							}
						}
					}
				},
				error: function (err) {
					displayMessage(err, button);
				}
			});
		});
	},

	addToWishlist: function () {
		$('.add-to-wish-list').on('click', function (e) {
			e.preventDefault();
			var $this = $(this);
			var url = $(this).data('href');
			var fromCart = $(this).data('fromcart') || null;
			var button = $(this);
			var pid = $(this).closest('.product-detail').find('.product-id').html() || $(this).data('pid');
			var setItemEle = $(this).parents('.product-detail.set-item');
			var isProductSet = setItemEle && setItemEle.length > 0 ? true : false;
			if ($(this).closest('.product-bundle').length > 0) {
				if ($(this).closest('.product-bundle')) {
					pid = $(this).closest('.product-bundle') ? $(this).closest('.product-bundle').data('pid') : '';
				}
			}
			if ($(this).closest('.set-item').length > 0) {
				$('body').find('.pdp-wishlist-message-block-set').empty(); 
				$(this)
					.parents('.set-item')
					.find('.pdp-wishlist-message-block-set').empty()
					.append('<div class="add-to-wishlist-messages"></div>');
			}
			var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
			var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
			optionId = optionId || null;
			optionVal = optionVal || null;
			if (!url || !pid) {
				return;
			}

			// Find rating from DOM element
			var productRating = '';
			if(isProductSet){
				var ratings;
				var ratingLabel = $(this).parents('.product-detail.set-item').find('.yotpo-stars .sr-only').text();
				if(ratingLabel){
					ratings = ratingLabel.split(' ');
					productRating = (ratings && ratings[0] > 0) ? parseFloat(ratings[0]) : ''; 
				}				
			}else{
				var productRatingEle = $('.product-detail .yotpo-main-widget .avg-score') && $('.product-detail .yotpo-main-widget .avg-score').length > 0 ? parseFloat($.trim($('.product-detail .yotpo-main-widget .avg-score').text())) : '';
				productRating = (productRatingEle > 0) ? parseFloat(productRatingEle) : '';
			}

			var navigatedPDPInfo = ($('#navigatedPDPInfo').length > 0) ? $('#navigatedPDPInfo').data('nav-pdpinfo') : '';
			var analyticsAddToWishlistData = [];
			if (productRating) {
				analyticsAddToWishlistData = [{'pid': pid, 'listName': sanitizeFieldInput(navigatedPDPInfo), 'productRating': productRating}];
			} else {
				analyticsAddToWishlistData = [{'pid': pid, 'listName': sanitizeFieldInput(navigatedPDPInfo)}];
			}

			if(isProductSet) {
				var stlID = $(this).closest('.product-set-detail').data('pid');
				analyticsAddToWishlistData[0].stlID = stlID;
			}

			$.spinner().start();
			$(this).attr('disabled', true);
			$.ajax({
				url: url,
				type: 'post',
				dataType: 'json',
				data: {
					pid: pid,
					optionId: optionId,
					optionVal: optionVal,
					fromCart: fromCart,
					analyticsAddToWishlistData:encodeURIComponent(JSON.stringify(analyticsAddToWishlistData))
				},
				success: function (data) {
					$('.pdp-wishlist-message-block').empty();
					if(data.success) {
						$('body').trigger('pdp:wishlistItem', data.pid); 
					}
					if (!data.success) {
						var $pdpContainer = $this.closest('.product-detail');
						var shippingStock = $pdpContainer.find('.shipping-delivery-selection .availability-msg');
						var pickupStoreStock = $pdpContainer.find('.shipping-pickup-store .availability-msg');
						var pdpStockMsgShown = shippingStock.find('.inStock').length > 0 || shippingStock.find('.outOfStock').length > 0 || 
							pickupStoreStock.find('.inStock').length > 0 || pickupStoreStock.find('.outOfStock').length > 0 ? true : false;
						if ($pdpContainer.find('.variation-value.selected').length === $pdpContainer.find('.variationOption').length && !pdpStockMsgShown) {
							// If all variation options selected and no stock messages shown, whether OOS/IS this implies 
							// selected variation not available for product.Then show not available message, else continue to appropriate error msg
							data.msg = $this.attr('data-not-available');
						}
					}
					displayMessage(data, button);
				},
				error: function (err) {
					$('.pdp-wishlist-message-block').empty();
					displayMessage(err, button);
				}
			});
		});
		$('body').on('click','.add-to-wishlist-messages button.close',function(){
			$('.add-to-wishlist-messages').remove();	
		});
	}
};
